import DeviceManager from '../utils/device-manager';
import Flickity from "flickity-fade";
import "flickity-imagesloaded";
import flickityEqualHeight from '../vendors/flickity-equal-height';

flickityEqualHeight();

class NewsSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            optionsMobile: {
                autoPlay: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: true,
                freeScroll: true,
                cellAlign: 'center',
                cellSelector: ".news-list__item",
                arrowShape: "M100,56.314l-0,-12.628l-75.829,0l34.758,-34.757l-8.929,-8.929l-50,50l50,50l8.929,-8.929l-34.758,-34.757l75.829,-0Z"
            },
			optionsDesktop: {
                autoPlay: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: true,
                freeScroll: true,
                cellAlign: 'left',
                cellSelector: ".news-list__item",
                arrowShape: "M100,56.314l-0,-12.628l-75.829,0l34.758,-34.757l-8.929,-8.929l-50,50l50,50l8.929,-8.929l-34.758,-34.757l75.829,-0Z"
            }
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.news-list__item');
        this.slidesCount = this.$slides.length;

        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this._createSliderMobile();
        } else {
            this._createSliderDesktop();
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.$el.flickity('destroy');
            this.slider = null;
        }
    }

	_createSliderMobile() {
        new Flickity(this.$el[0], this.options.optionsMobile);
    }

    _createSliderDesktop() {
        new Flickity(this.$el[0], this.options.optionsDesktop);
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this._destroy();
            this._createSliderMobile();
        } else {
            this._destroy();
            this._createSliderDesktop();
        }
    }

}

export default NewsSlider;